export default Object.freeze({
  GEO: {
    RESIDENTS: 1,
    NOT_RESIDENTS: 2,
    COORDINATES_DECIMALS: 100,
  },
});
